import { useTranslation } from 'react-i18next';
import {
  QUALITY_COLORS,
  CongestionListContainer,
  CongestionListScrollable,
  CongestionChannelLabel,
  CongestionBarWrapper,
  CongestionBarFill,
  CongestionCountLabel,
  CongestionListHeader,
  CongestionListItem,
  CongestionHeaderLabel,
} from '../styles';

interface ChannelCongestionListProps {
  ranking: BandResult['ranking'];
}

// Displays a list of channels with their congestion levels based on the number of networks
export function ChannelCongestionList({ ranking }: ChannelCongestionListProps) {
  const { t } = useTranslation();

  const maxNetworks =
    ranking.length > 0 ? Math.max(...ranking.map((r) => r.networkCount)) : 0;

  const getWidthByCount = (count: number) => {
    if (maxNetworks === 0) return '0%';
    return `${(count / maxNetworks) * 100}%`;
  };

  return (
    <CongestionListContainer>
      <CongestionListHeader>
        <CongestionHeaderLabel variant="caption">
          {t('scanner.channels')}
        </CongestionHeaderLabel>
        <CongestionHeaderLabel variant="caption">
          {t('scanner.interference.title')}
        </CongestionHeaderLabel>
        <CongestionHeaderLabel variant="caption">
          {t('scanner.networks')}
        </CongestionHeaderLabel>
      </CongestionListHeader>

      <CongestionListScrollable gap="16px">
        {[...ranking]
          .sort((a, b) => b.networkCount - a.networkCount)
          .map((r) => (
            <CongestionListItem key={r.channel}>
              <CongestionChannelLabel variant="body2">
                {t('scanner.channelPrefix', { channel: r.channel })}
              </CongestionChannelLabel>

              <CongestionBarWrapper>
                <CongestionBarFill
                  fillwidth={getWidthByCount(r.networkCount)}
                  fillcolor={QUALITY_COLORS[r.quality]}
                />
              </CongestionBarWrapper>

              <CongestionCountLabel variant="body2">
                {r.networkCount}
              </CongestionCountLabel>
            </CongestionListItem>
          ))}
      </CongestionListScrollable>
    </CongestionListContainer>
  );
}
